// @flow
import DomainSuggestionTool from './DomainSuggestionTool';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import * as r from 'ramda';
import * as signals from '../../application/signals';
import * as selectors from '../../domain/selectors';

const mapStateToProps = (state, ownProps) => {
  const dst = selectors.getDst(state);

  return {
    query: selectors.getUserQuery(state),
    searching: selectors.isSearching(state),
    filtering: selectors.isFiltering(state),
    filters: dst.filters,
    error: selectors.getSearchError(state),
    errored: selectors.hasErrored(state),
    // anyResults: selectors.hasAnyResults(state, {
    //   features: ownProps.features,
    // }),
    results: {
      exactMatchDomainStatus: selectors.getDomainStatus(state, {
        basketFqdns: ownProps.basketFqdns,
      }),
      exactMatch: r.defaultTo({}, selectors.getExactMatch(state, {
        legal: ownProps.legal,
        features: ownProps.features,
        transferableTlds: ownProps.transferableTlds,
        backorderableTlds: ownProps.backorderableTlds,
        negotiableTlds: ownProps.negotiableTlds,
        basketFqdns: ownProps.basketFqdns,
        displayPricing: ownProps.displayPricing,
      })),
      bundleAvailability: selectors.getBundleAvailability(state),
      standard: selectors.getSearchResults(state, {
        legal: ownProps.legal,
        basketFqdns: ownProps.basketFqdns,
        unspunTlds: ownProps.features.canUnspin ? ownProps.unspunTlds : [],
        features: ownProps.features,
        displayPricing: ownProps.displayPricing,
      }),
    },
    bundleOptions: selectors.getBundleConfig(state),
    hasSearched: selectors.hasSearched(state),
    taxRate: selectors.getAverageTaxRate(state),
    afternicInBasket: selectors.isAfternicInBaket(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    purchaseDomain: signals.purchaseDomain,
    purchaseBundle: signals.purchaseBundle,
    search: signals.search,
    filter: signals.filter,
    transfer: signals.transfer,
    backorder: signals.backorder,
    negotiate: signals.negotiate,
    viewBasket: signals.viewBasket,
  }, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...ownProps,
    actions: {
      ...dispatchProps,
      ...ownProps.actions,
    },
  };
};

export const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    searchDomains: ({
      actions,
      filters,
    }) => (query, source) => actions.search(
      query,
      filters,
      source,
    ),
  }),
  withHandlers({
    onPurchaseDomainClick: ({
      actions,
    }) => (fqdn) => actions.purchaseDomain(fqdn),
    onPurchaseBundleClick: ({ actions }) => (fqdn, bundles) => {
      actions.purchaseBundle(fqdn, bundles);
    },
    onTransferDomainClick: ({
      actions,
    }) => (fqdn) => actions.transfer(fqdn),
    onBackorderDomainClick: ({
      actions,
    }) => (fqdn) => actions.backorder(fqdn),
    onNegotiateDomainClick: ({
      actions,
    }) => (fqdn) => actions.negotiate(fqdn),

    // Static Search
    onStaticSearchFormSubmit: ({
      searchDomains,
    }) => (values) => searchDomains(values.query, 'static'),
    onStaticSearchFormChange: ({
      searchDomains,
    }) => (values) => searchDomains(values.query, 'static'),

    // Sticky Search
    onStickySearchFormSubmit: ({
      searchDomains,
    }) => (values) => searchDomains(values.query, 'sticky'),
    onStickySearchFormChange: ({
      searchDomains,
    }) => (values) => searchDomains(values.query, 'sticky'),

    onFilterFormChange: ({
      actions,
    }) => (values) => actions.filter(values),

    onViewBasketClick: ({ actions }) => (source) => {
      actions.viewBasket({
        source,
      });
    },
  }),
);

export default enhance(DomainSuggestionTool);
